import { Button, ButtonProps } from '@cmpsr/components';
import { ForwardedRef, forwardRef } from 'react';
import { useNavigate } from 'react-router-dom';

type NavigationButtonProps = {
  to: string;
  children: React.ReactNode;
} & ButtonProps;

const NavigationButton = forwardRef((props: NavigationButtonProps, ref: ForwardedRef<HTMLButtonElement>) => {
  const navigate = useNavigate();

  const handleClick = () => {
    // Skip navigation if button is disabled
    if (props.disabled) {
      return;
    }

    const isExternal = props.to.match(/^https?:\/\//);

    if (isExternal) {
      // For external URLs
      window.location.href = props.to;
    } else {
      // For relative URLs, use React Router's navigate
      navigate(props.to);
      // Scroll to top of the page
      window.scrollTo(0, 0);
    }
  };

  return (
    <Button ref={ref} onClick={handleClick} {...props}>
      {props.children}
    </Button>
  );
});

NavigationButton.displayName = 'NavigationButton';

export default NavigationButton;
